export default __webpack_public_path__ + "static/media/oscer-full-logo-dark.a6ba677e.svg";